import React, { useState, useEffect } from 'react';
import UserTable from './UserTable';
import { getUsers, clearUsers } from '../../flux/actions/userActions';
import { getAllSocietes, clearSocietes } from '../../flux/actions/societeActions';
import { Container, Row, Col, Button } from 'reactstrap';

import { connect } from 'react-redux';
import { UserContainer, IUserReduxProps } from '../../types/interfaces';
import UserAdd from './UserAdd';
import LoadingPage from '../../pages/loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUsers } from '@fortawesome/free-solid-svg-icons'

const UserContainerComponent = ({
  getUsers,
  clearUsers,
  getAllSocietes,
  clearSocietes,
  user,
  societe
 }: UserContainer) => {

  const { users, loading } = user;
  const { societes, loading: loadingS } = societe;
  const [tableData, setTableData] = useState(users);
  const [modal, setModal] = useState(false);
  
  const handleToggle = () => setModal(!modal);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  useEffect(() => getAllSocietes(), [getAllSocietes])

  useEffect(() => {
    return () => {
      // clearUsers();
      clearSocietes();
    }
  }, []);

  useEffect(() => {
    setTableData(users);
  }, [users]);

  return loading ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" md="8"><h2 className="title"><FontAwesomeIcon icon={faUsers} />&nbsp;&nbsp;Liste des Utilisateurs</h2></Col>
          <Col xs="12" md="4" className="modalAddBtnCol">
            <Button
              className="btn btn-success linesConfirmationBtn"
              onClick={() => setModal(true)}
              ><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajouter un utilisateur</Button>
          </Col>
        </Row>
      </Container>
      <UserTable usersData={tableData} setTableData={setTableData} societes={societes} />
      <UserAdd modal={modal} setModal={setModal} handleToggle={handleToggle} users={users} societes={societes} />
    </>
  );
};

const mapStateToProps = (state: IUserReduxProps) => ({
  user: state.user,
  societe: state.societe,
  auth: state.auth
});

export default connect(mapStateToProps, { getUsers, getAllSocietes, clearUsers, clearSocietes })(UserContainerComponent);
